"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CAROUSEL_DOCUMENTS_QUERY = void 0;
const client_1 = require("@apollo/client");
exports.CAROUSEL_DOCUMENTS_QUERY = (0, client_1.gql) `
  query getCarouselDocuments($objectId: ID!, $objectType: ObjectType!) {
    getDocumentUploadsForTargetObject(
      objectId: $objectId
      objectType: $objectType
      filterProcessing: true
      carouselDocumentsOnly: true
    ) {
      id
      accountDocumentType {
        id
        name
      }
      mimeType
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0Q2Fyb3VzZWxEb2N1bWVudHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9jb21wb25lbnRzL0NvbW1vbi9DYXJvdXNlbC9fX3F1ZXJpZXNfXy9nZXRDYXJvdXNlbERvY3VtZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSwyQ0FBcUM7QUFFeEIsUUFBQSx3QkFBd0IsR0FBRyxJQUFBLFlBQUcsRUFBQTs7Ozs7Ozs7Ozs7Ozs7OztDQWdCMUMsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGdxbCB9IGZyb20gXCJAYXBvbGxvL2NsaWVudFwiO1xuXG5leHBvcnQgY29uc3QgQ0FST1VTRUxfRE9DVU1FTlRTX1FVRVJZID0gZ3FsYFxuICBxdWVyeSBnZXRDYXJvdXNlbERvY3VtZW50cygkb2JqZWN0SWQ6IElEISwgJG9iamVjdFR5cGU6IE9iamVjdFR5cGUhKSB7XG4gICAgZ2V0RG9jdW1lbnRVcGxvYWRzRm9yVGFyZ2V0T2JqZWN0KFxuICAgICAgb2JqZWN0SWQ6ICRvYmplY3RJZFxuICAgICAgb2JqZWN0VHlwZTogJG9iamVjdFR5cGVcbiAgICAgIGZpbHRlclByb2Nlc3Npbmc6IHRydWVcbiAgICAgIGNhcm91c2VsRG9jdW1lbnRzT25seTogdHJ1ZVxuICAgICkge1xuICAgICAgaWRcbiAgICAgIGFjY291bnREb2N1bWVudFR5cGUge1xuICAgICAgICBpZFxuICAgICAgICBuYW1lXG4gICAgICB9XG4gICAgICBtaW1lVHlwZVxuICAgIH1cbiAgfVxuYDtcbiJdfQ==